import React from 'react';
import { ALL_PRODUCT_TYPES, ALL_PRODUCT_TYPES_STACKED } from './constants';
import { LabeledSelectBox } from './LabeledSelectBox';

export const LabeledProductTypeSelectBox = ({ productTypeNames, selectedProductTypeName, onProductTypeChanged }) => {
    if (!productTypeNames) {
        return null;
    }

    if (!productTypeNames.length) {
        return <p>No product types found for the selected section.</p>
    }

    productTypeNames.unshift(ALL_PRODUCT_TYPES_STACKED);
    productTypeNames.unshift(ALL_PRODUCT_TYPES);
    return (
        <LabeledSelectBox
            label="Product Type:"
            items={productTypeNames}
            selectedValue={selectedProductTypeName || ALL_PRODUCT_TYPES}
            onSelectionChanged={value => onProductTypeChanged(value)}
        />
    )
}
